import Loadable from 'react-loadable';

export const OnboardingView = Loadable({
  loader: () => import(/* webpackChunkName: "OnboardingView" */ './components/OnboardingView'),
  loading: () => null,
});

export { onboardingViewResource } from './resources/onboarding-view';
export { getInitialDomains } from './util';
